export const UNSET_STATUS_PSUEDO_DUID = "@unset";
export const UNSET_STATUS_LABEL = "(Unset)";
export const UNCHANGED_STATUS_LABEL = "(Unchanged)";
